export const removeLeadingZero = (str: string) => {
  return str.replace(/^[0:]+(?=\d[\d:]{3})/, '');
};
